import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/COMP0016_2020_21_Team20/COMP0016_2020_21_Team20/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import LeaveDeptButton from './LeaveDeptButton';
import 'rsuite/dist/styles/rsuite-default.min.css';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "leavedeptbutton"
    }}>{`LeaveDeptButton`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`LeaveDeptButton`}</inlineCode>{` component is used in the header to allow users to leave their department in case they are quitting or are joining a different one.`}</p>
    <Props of={LeaveDeptButton} mdxType="Props" />
    <p>{`It is normally used in conjunction with the `}<a parentName="p" {...{
        "href": "/COMP0016_2020_21_Team20/frontend/Header"
      }}><inlineCode parentName="a">{`Header`}</inlineCode></a>{` wrapper component.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={1} __code={'<LeaveDeptButton />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      LeaveDeptButton,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <LeaveDeptButton mdxType="LeaveDeptButton" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      